import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { size, get, find } from 'lodash';
import { OAuthActions } from '../config/Authentication';
import * as ActionTypes from '../constants/ActionTypes';
import { httpClient } from '../../lib/utils';
import { ThemeService } from '../services/ThemeService';
import { SAVE_LEVEL } from '../constants/Level';
import { ConfigurationService, fetchRetailProductCategories } from '../services/ConfigurationService';
import { HOTEL_LIST_MAX_LENGTH } from '../constants/HotelConstants';
import { CALCULATE_FONT_USAGE } from '../constants/ActionTypes';
import { IsTestEnv } from '../utils/configuration-utils';
import { fetchLanguages } from './helpers/fetchLanguages';
import { fetchEnglishLabels } from './helpers/fetchLabels';
import { getAndSetInContextBetaForLogin } from './helpers/getAndSetInContextBetaForLogin';
import InputTextField from './common/InputTextField';

const isTestEnv = IsTestEnv();

class Login extends Component {
    constructor() {
        super();
        this.onLogin = this.onLogin.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this._onLoginCB = this._onLoginCB.bind(this);
        this.state = { error: null };
        this.intervalId = null;
    }

    componentWillMount() {
        const token = get(this.props.location, 'query.token', sessionStorage.getItem('token'));
        const hotelIdFromCrs = get(this.props.location, 'query.HotelId', sessionStorage.getItem('hotelIdFromCrs'));
        this.setState({
            username: '',
            password: '',
            isPasswordActive: false
        });

        if (token) {
            this.hasToken = true;
            this.props.actions.get_token(
                { token: token.replace(/ /g, '+'), hotelIdFromCrs },
                this._onLoginCB,
                this.props.location.query && this.props.location.query.newLogin
            );
        }
    }

    onLogin() {
        this.setState({ error: null });

        this.props.actions.get_token(
            {
                username: this.state.username,
                password: this.state.password
            },
            this._onLoginCB,
            this.props.location.query && this.props.location.query.newLogin
        );
        return false;
    }

    onLogout() {
        this.props.actions.signout();
    }

    onUsernameChange(username) {
        this.setState({ username });
    }

    onPasswordChange(event) {
        const password = get(event, 'target.value', '');
        const isPasswordActive = !!password;

        this.setState({ password, isPasswordActive });
    }

    onPasswordFocus() {
        this.setState({ isPasswordActive: true });
    }

    onPasswordBlur() {
        const isPasswordActive = !!get(this, 'state.password');
        this.setState({ isPasswordActive });
    }

    _onLoginCB(data) {
        if (data) {
            if (typeof data.error !== 'undefined') {
                if (data.error.error) {
                    this.setState({ error: data.error.error });
                } else if (data.error.message === 'Token invalid or inactive') {
                    this.setState({ error: 'Invalid token. Please close this window and log in to CRS again.' });
                }
            } else {
                let selectedHotel = data.data.initialState.hotellist.find(elem => elem.id === data.defaultHotel);
                const selectedHotelIndex = data.data.initialState.hotellist.indexOf(selectedHotel);
                data.data.initialState.hotellist[selectedHotelIndex].selected = true;
                if (!selectedHotel) {
                    // if no hotel is selected as default -> select first hotel
                    selectedHotel = data.data.initialState.hotellist[0];
                    data.data.initialState.hotellist[0].selected = true;
                }
                const hotellist = get(data, 'data.initialState.hotellist', []);
                if (size(hotellist) <= HOTEL_LIST_MAX_LENGTH) {
                    this.props.onReceiveHotelList(hotellist);
                }
                this.props.onReceiveChainList(data.listOfChains, data.accessibleChains);
                this.props.setDefaultHotel(selectedHotel);
                httpClient.defaults.baseURL = '';
                const chainId = this.props.reduxState.app.selected.chain.Id;
                const hotelId = this.props.reduxState.app.selected.selectedHotel.id;
                fetchLanguages(hotelId, this.props.setLanguageList, this.props.setCustomContentLanguageCode).then((response) => {
                    const languageCode = get(find(response, { isDefault: true }), 'code') || 'en-US';
                    fetchRetailProductCategories({ hotelId, languageCode })
                });
                fetchEnglishLabels(chainId, hotelId, 'en-US');
                ThemeService.reload(chainId, hotelId, SAVE_LEVEL.HOTEL);
                ConfigurationService.reload(chainId, hotelId, SAVE_LEVEL.HOTEL);
                getAndSetInContextBetaForLogin(chainId, hotelId, SAVE_LEVEL.HOTEL);

                // successfully logged in
                // redirect to "/"
                this.props.router.push('/');
            }
        }
    }

    render() {
        const isAuthenticating = !!this.props.reduxState.authReducer.authenticating;
        const productionMessage = (
            <p className="spark-margin-top--lg spark-margin-bottom">
                <p> You may only log in to BE Designer through the Control Center application. </p>
                <p>
                    {' '}
                    Log into Control Center, then select the Setup -> Channels -> BE Designer link to enter BE Designer.{' '}
                </p>
            </p>
        );

        const testEnvForm = (
            <form
                method="post"
                className="spark-splash-screen__form spark-text-left"
                onSubmit={e => e.preventDefault()}
            >
                <p className="spark-margin-top--lg spark-margin-bottom">Sign in to Booking Engine Designer.</p>
                <InputTextField
                    sparkInputProps={{ label: 'Username' }}
                    disabled={isAuthenticating}
                    name="username"
                    placeholder="Enter Username..."
                    value={this.state.username}
                    required
                    onChange={value => this.onUsernameChange(value)}
                />
                <label htmlFor="password" className={`spark-input ${this.state.isPasswordActive ? 'active' : ''}`}>
                    <input
                        disabled={isAuthenticating}
                        ref={component => {
                            this.passwordInput = component;
                        }}
                        onChange={event => this.onPasswordChange(event)}
                        type="password"
                        className="spark-input__field"
                        name="password"
                        id="password"
                        value={this.state.password}
                        placeholder="What is your password?"
                        role="textbox"
                        required
                        style={{ cursor: 'auto' }}
                    />
                    <span className="spark-label">Password</span>
                </label>
            </form>
        );
        const testEnvFormSubmitButton = (
            <div className="row">
                <div className="col-xs-12 spark-margin-top">
                    {isAuthenticating ? (
                        <button className="spark-btn spark-progress spark-btn--md spark-btn--primary spark-block--lte-sm spark-margin-bottom--md spark-pull-right--gte-sm">
                            <progress />
                            <span className="spark-progress__meter" />
                            Processing...
                        </button>
                    ) : (
                        <button
                            onClick={this.onLogin}
                            className="spark-btn spark-btn--md spark-btn--primary spark-block--lte-sm spark-margin-bottom--md spark-pull-right--gte-sm"
                        >
                            Sign In
                        </button>
                    )}
                </div>
            </div>
        );
        return (
            <div className="spark-content__wrapper">
                <article
                    className="spark-splash-screen spark-splash-screen--panel spark-splash-screen--sign-in spark-main--sticky-footer"
                    id="sign-in-progress-bar-example"
                >
                    <section className="spark-splash-screen__content">
                        <div className="spark-panel spark-splash-screen__center col-xs-12 col-md-10 col-lg-8 col-xl-6">
                            {this.hasToken ? (
                                this.state.error ? (
                                    <div className="spark-panel__content spark-message spark-message--error">
                                        <i className="spark-message__icon spark-icon-ban spark-icon--fill" />
                                        <p className="spark-message__content">
                                            <b>Error.</b> {this.state.error}
                                        </p>
                                    </div>
                                ) : (
                                    <div className="spark-panel__content">
                                        <img
                                            src="/public/images/aven-logo.png"
                                            style={{ height: 60, minHeight: 120, minWidth: '3rem', padding: '0 .5rem' }}
                                        />
                                        <div className="splashscreen-title">Booking Engine Designer</div>
                                        <h2>Loading...</h2>
                                        <div className="login-spinner">
                                            <div />
                                        </div>
                                    </div>
                                )
                            ) : (
                                <div className="spark-panel__content">
                                    <img
                                        src="/public/images/aven-logo.png"
                                        style={{ height: 60, minHeight: 120, minWidth: '3rem', padding: '0 .5rem' }}
                                    />
                                    {isTestEnv ? testEnvForm : productionMessage}
                                    <div className="spark-message spark-message--error">
                                        {this.state.error ? (
                                            <i className="spark-message__icon spark-icon-ban spark-icon--fill" />
                                        ) : (
                                            <i
                                                style={{
                                                    height: '3rem',
                                                    minHeight: '3rem',
                                                    minWidth: '3rem',
                                                    padding: '0 .5rem'
                                                }}
                                            />
                                        )}
                                        <p className="spark-message__content">
                                            {this.state.error ? (
                                                <span>
                                                    <b>Error.</b> {this.state.error}
                                                </span>
                                            ) : null}
                                        </p>
                                    </div>
                                    {isTestEnv && testEnvFormSubmitButton}
                                </div>
                            )}
                        </div>
                    </section>
                </article>
            </div>
        );
    }
}

Login.propTypes = {
    oauth: PropTypes.object.isRequired,
    actions: PropTypes.shape({
        get_token: PropTypes.func.isRequired,
        signout: PropTypes.func.isRequired
    }),
    router: PropTypes.object.isRequired
};

const mapLoginStateToProps = state => {
    return {
        reduxState: state,
        oauth: state.oauth,
        selected: state.app.selected,
        theme: state.app.selected,
        defaultLanguageCode: state.app.selected.defaultCode
    };
};

const mapLoginDispatchToProps = dispatch => {
    return {
        onReceiveHotelList: hotelList => {
            dispatch({ type: ActionTypes.LOGIN_SET_HOTELLIST, hotelList });
        },
        onReceiveChainList: (chainList, accessibleChains) => {
            dispatch({
                type: ActionTypes.LOGIN_SET_CHAINLIST,
                chainList,
                accessibleChains
            });
        },
        setDefaultHotel: hotel => {
            dispatch({ type: ActionTypes.LOGIN_SET_DEFAULT_HOTEL, defaultHotel: hotel });
        },
        initCurrentChain: chain => {
            dispatch({ type: ActionTypes.LOGIN_SET_CHAINID, chain });
        },
        setTheme: (theme, code) => {
            dispatch({ type: ActionTypes.LOGIN_SET_THEME, theme, code });
            dispatch({ type: CALCULATE_FONT_USAGE });
        },
        setConfig: (theme, code) => {
            dispatch({ type: ActionTypes.LOGIN_SET_CONFIG, config: theme, code });
        },
        setThemeList: (themeList, defaultContentCode) => {
            dispatch({ type: ActionTypes.ADD_THEME_LIST, themeList, defaultContentCode });
        },
        setConfigList: (configList, defaultContent) => {
            dispatch({ type: ActionTypes.ADD_CONFIG_LIST, configList, defaultContent });
        },
        setLabels: (foldedValue, explicitValue, languageCode) => {
            dispatch({ type: ActionTypes.SET_LABELS, foldedValue, explicitValue, languageCode });
        },
        setHigherOrderLabels: foldedValue => {
            dispatch({ type: ActionTypes.SET_HIGHER_ORDER_LABELS, foldedValue });
        },
        setLanguageList: (languageList, languageCode) => {
            dispatch({ type: ActionTypes.SET_LANGUAGE_LIST, languageList, languageCode });
        },
        setCustomContentLanguageCode: languageCode => {
            dispatch({ type: ActionTypes.CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, languageCode });
        },
        actions: bindActionCreators(OAuthActions, dispatch)
    };
};

export default connect(mapLoginStateToProps, mapLoginDispatchToProps)(withRouter(Login));



// WEBPACK FOOTER //
// ./src/components/Login.js